import React from 'react';
import Hero from '../components/Sections/Hero';
import About from '../components/Sections/About';
import Feature from '../components/Sections/Feature';
import Service from '../components/Sections/Service';
import CaseStudies from '../components/Sections/CaseStudies';
import Testimonials from '../components/Sections/Testimonials';
import Cta from '../components/Sections/Cta';
import Team from '../components/Sections/Team';
import Contact from '../components/Sections/Contact';
import Blog from '../components/Sections/Blog';

function HomePage() {
    return (
        <>
            <Hero />
            <About />
            <Feature />
            <Service />
            <CaseStudies />
            <Testimonials />
            <Cta />
            <Team />
            <Contact />
            <Blog />
        </>
    );
}

export default HomePage;